function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classnames from 'classnames';
import PropTypes from 'prop-types';
import validator from 'validator';
import { Input, Label } from 'reactstrap';
import React, { Component } from 'react';
import lodash from 'lodash';
import entityComposition from '../classes/entityComposition';
import Icon from '../containers/icon';
class TextInput extends Component {
  constructor(props) {
    super(props);
    props.schemaActions.refresh();
    this.state = {
      errorMaxLength: false,
      errorInvalidEmail: false
    };
    this.getMaxLength = this.getMaxLength.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePaste = this.handlePaste.bind(this);
  }
  getMaxLength() {
    const {
      props
    } = this;
    return lodash.get(props.schema, `${props.entity}.${props.field}.maxLength`, 100);
  }

  /* @method getValue - returns the value from the props.
     *   if not defined, then it returns an empty string.  This forces
     *   the input to be controlled from the get go so we don't have to
     *   change our minds later.
     */
  getValue() {
    let result = '';
    const {
      value,
      field,
      data
    } = this.props;
    if (value !== null) {
      result = value || '';
    } else {
      result = data[field] || '';
    }
    return result;
  }
  handleBlur() {
    let errorInvalidEmail = false;
    const {
      type
    } = this.props;
    const value = this.getValue();
    if (type === 'email') {
      if (value && value.length > 0 && !validator.isEmail(value)) {
        errorInvalidEmail = true;
      }
    }
    this.setState({
      errorMaxLength: false,
      errorInvalidEmail
    });
  }
  handleChange(ev) {
    const {
      onChange,
      field
    } = this.props;
    let {
      value
    } = ev.target;
    let newErrorMaxLength = false;
    // always set invalid email to false onChange if not already.
    const newErrorInvalidEmail = false;
    const {
      errorInvalidEmail,
      errorMaxLength
    } = this.state;
    if (value.length > this.getMaxLength()) {
      value = value.substring(0, this.getMaxLength());
      newErrorMaxLength = true;
    }
    if (errorInvalidEmail !== newErrorInvalidEmail || errorMaxLength !== newErrorMaxLength) {
      this.setState({
        errorMaxLength: newErrorMaxLength,
        errorInvalidEmail: newErrorInvalidEmail
      });
    }
    onChange(field, value);
  }
  handlePaste(ev) {
    const {
      notificationActions
    } = this.props;

    // This gets the text that was pasted, tested on Chrome, Firefox and Safari.
    const pastedText = ev.nativeEvent.clipboardData.getData('text');

    // If pasted text is too long, don't paste and show the error message
    if (pastedText.length > this.getMaxLength()) {
      ev.preventDefault();
      notificationActions.error({
        message: `The maximum length for an entry in this field is ${this.getMaxLength()} characters.`,
        id: 'too_long_past_error'
      });
      this.setState({
        errorMaxLength: true
      });
    }
  }
  render() {
    const {
      errorMaxLength,
      errorInvalidEmail
    } = this.state;
    const {
      className,
      hideLabel,
      label,
      autofocus,
      field,
      type,
      placeholder,
      style
    } = this.props;
    const styles = {
      spanErrorInvalidEmail: {
        width: '200px'
      },
      spanErrorMaxLength: {
        width: '150px'
      },
      inputErrorInvalidEmail: {
        paddingRight: '110px'
      },
      inputErrorMaxLength: {
        paddingRight: '85px'
      },
      msg: {
        top: hideLabel ? '7px' : '32px',
        right: '30px',
        position: 'absolute'
      }
    };
    const hasErrors = errorMaxLength || errorInvalidEmail;
    const classes = classnames({
      'form-group': true,
      'has-error': hasErrors,
      'has-feedback': hasErrors
    });

    // Determine the feedback text
    let inputStyle;
    let spanStyle;
    let msg;
    if (errorMaxLength) {
      inputStyle = styles.inputErrorMaxLength;
      spanStyle = styles.spanErrorMaxLength;
      msg = 'too long';
    } else if (errorInvalidEmail) {
      inputStyle = styles.inputErrorInvalidEmail;
      spanStyle = styles.spanErrorInvalidEmail;
      msg = 'invalid email';
    }
    const feedback = /*#__PURE__*/React.createElement("span", {
      className: "t-ti-feedback",
      "aria-hidden": "true",
      style: spanStyle
    }, /*#__PURE__*/React.createElement("span", {
      style: styles.msg
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "times"
    }), " ", msg));
    const displayLabel = hideLabel ? '' : /*#__PURE__*/React.createElement(Label, null, label);
    const classNames = `t-ti-input tqc-control t-ti-${lodash.kebabCase(field)} ${className}`;
    return /*#__PURE__*/React.createElement("div", {
      className: classes
    }, displayLabel, /*#__PURE__*/React.createElement(Input, {
      autoFocus: autofocus,
      type: type,
      value: this.getValue(),
      onChange: this.handleChange,
      className: `form-control ${classNames}`,
      onPasteCapture: this.handlePaste,
      onBlur: this.handleBlur,
      invalid: hasErrors,
      style: _objectSpread(_objectSpread({}, inputStyle), style),
      placeholder: placeholder
    }), hasErrors ? feedback : '');
  }
}
TextInput.propTypes = {
  autofocus: PropTypes.bool,
  className: PropTypes.string,
  schema: PropTypes.shape({}),
  schemaActions: PropTypes.shape({
    refresh: PropTypes.func
  }).isRequired,
  data: PropTypes.shape({
    name: PropTypes.string
  }),
  style: PropTypes.shape({}),
  entity: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired
};
TextInput.defaultProps = {
  className: '',
  data: {},
  schema: {},
  style: {},
  value: null,
  autofocus: false,
  hideLabel: false,
  label: '\u00a0',
  placeholder: '',
  type: 'text'
};
export { TextInput as TestTextInput };
export default entityComposition(TextInput, ['schema'], {}, ['notification']);